export default __webpack_public_path__ + "static/media/yw-icons.735310c4.svg";